<template>
  <quick-add-modal  @addToCart="addToCart"
                    @cancel="$emit('cancel')"/>
</template>

<script>
import { mapActions } from "vuex"
import QuickAddModal from "@/components/common/QuickAddModal"
export default {
  name: "OrderQuickAddModalWrapper",
  components: { QuickAddModal },
  methods: {
    ...mapActions({
      addToCart: "order/addItemToOrder"
    })
  }
}
</script>